import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import IconExit from '../../../assets/iconExit.svg';
import IconCloseWhite from '../../../assets/icon-close-white.svg';
import IconSidebarArrow from '../../../assets/icon-sidebar-arrow.svg';

export const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 210px;
  height: 100%;
  background-color: #1a1d23;
  z-index: 16;
  transition-property: transform;
  transition-duration: 0.3s;

  @media (max-width: 1250px) {
    transform: translateX(-100%);

    &.isOpen {
      transform: translateX(0);
      .SidebarOverlay {
        transition-delay: 0.3s;
        opacity: 1;
        visibility: visible;
      }
    }
  }
`;

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1 1 auto;
  z-index: 2;
  overflow-y: auto;
  background-color: #1a1d23;
`;

export const SidebarOverlay = styled.div`
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 200vw;
  height: 200vh;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  background-image: url('${IconCloseWhite}');
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: left 238px top 32px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition-property: opacity, visibility;
  transition-duration: 0.3s;
`;

export const SidebarTitle = styled.div`
  display: block;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.24em;
  color: #888;
  padding-left: 14px;
  margin-bottom: 4px;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  min-height: 56px;
  padding: 0 18px;
  border-bottom: 1px solid #333;
  flex: 0 0 auto;

  img {
    display: block;
    width: 100%;
    max-width: 120px;
  }
`;

export const SidebarLocationWrapper = styled.div`
  position: relative;

  @media (max-width: 1250px) {
    display: none;
  }
`;

export const SidebarLocation = styled.div`
  padding: 10px 14px;
  border-bottom: 1px solid #333;
  flex: 0 0 auto;
`;

export const SidebarLocationLabel = styled.div`
  font-size: 10px;
  color: #aaa;
  line-height: 1;
  margin-bottom: 4px;
  height: 15px;
`;

export const SidebarLocationSelectWrapper = styled.div`
  .MuiFormControl-root {
    background: transparent;
    border: 0;
    border-radius: 0;
    padding: 0;
    width: 100%;
  }

  .MuiSelect-select.MuiSelect-select {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.2;
    color: #fff;
    padding: 0 16px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MuiSelect-select:focus {
    background: transparent;
  }

  .MuiSelect-icon {
    background-image: url('${IconSidebarArrow}');
    background-repeat: no-repeat;
    background-size: 8px;
    background-position: center;
    right: 0;

    path {
      display: none;
    }
  }
`;

export const SidebarHolder = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SidebarMenu = styled.ul`
  display: block;
  flex: 1 1 auto;
  padding: 6px 0;
`;

export const MenuItem = styled.li`
  display: block;

  & > ul {
    display: none;
    &.isOpen {
      display: block;

      li a {
        padding: 6px 0 6px 40px;
        font-size: 13px;
        line-height: 1.5;
        color: #aaa;
        font-weight: 400;

        &:hover {
          color: rgba(255, 255, 255, 0.85);
          background-color: rgba(255, 255, 255, 0.04);
          border-left-color: transparent;
        }

        &.isActive {
          color: #e63946;
          font-weight: 600;
          background-color: transparent;
          border-left-color: transparent;
        }
      }
    }
  }
`;

export const SidebarNew = styled.div`
  flex: 0 0 auto;
  margin-left: 4px;
  margin-right: 5px;
  width: 35px;
  height: 16px;
  text-align: center;
  line-height: 16px;
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  color: #fff;
  background: linear-gradient(105.63deg, #ff2d38 39.07%, #f0868c 96.81%);
  border-radius: 25px;
`;

// Sits right after the label (inside the flex label span) instead of being
// pushed to the right edge like SidebarNew.
export const SidebarNewInline = styled(SidebarNew)`
  margin-left: 8px;
  margin-right: 0;

  /* Rendered as a span inside the label span; && beats the menu button's
     generic span rule (flex: 1 1 auto; display: flex; height: 18px). */
  && {
    flex: 0 0 auto;
    display: block;
    height: 16px;
  }
`;

export const SidebarMenuButton = styled(NavLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  width: 100%;
  outline: none;
  border: none;
  border-left: 3px solid transparent;
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: #fff;
  background-color: transparent;
  padding: 9px 14px;
  transition-property: color, background-color, border-left-color;
  transition-duration: 0.2s;

  span {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 18px;
  }

  svg:first-of-type {
    display: inline-block;
    margin-right: 8px;
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    color: currentColor;
    transition: color 0.2s;
  }

  &:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.05);
    svg:first-of-type {
      color: #e63946;
    }
  }

  &.isActive {
    color: #fff;
    font-weight: 600;
    background-color: rgba(230, 57, 70, 0.13);
    border-left-color: #e63946;
    svg:first-of-type {
      color: #e63946;
    }
  }

  &.isDisabled {
    pointer-events: none;
  }
`;

export const SidebarMenuGroupButton = styled.button`
  text-decoration: none;
  display: flex;
  align-items: center;
  width: 100%;
  outline: none;
  border: none;
  border-left: 3px solid transparent;
  cursor: pointer;
  font-family: inherit;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: #fff;
  background-color: transparent;
  padding: 9px 14px;
  text-align: left;
  transition-property: color, background-color, border-left-color;
  transition-duration: 0.2s;

  span {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 18px;
  }

  svg:first-of-type {
    display: inline-block;
    margin-right: 8px;
    flex-shrink: 0;
    width: 14px;
    height: 14px;
    color: currentColor;
    transition: color 0.2s;
  }

  &:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.05);
    svg:first-of-type {
      color: #e63946;
    }
  }

  &.isActive {
    color: #fff;
    font-weight: 600;
    background-color: rgba(230, 57, 70, 0.13);
    border-left-color: #e63946;
    svg:first-of-type {
      color: #e63946;
    }
  }
`;

export const SidebarProfile = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-top: 1px solid #333;
  position: relative;
  z-index: 2;
  background-color: #1a1d23;
`;

export const SidebarProfilePhoto = styled.img`
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  background-color: #ccc;
  border-radius: 50%;
  object-fit: cover;
  object-position: center top;
`;

export const SidebarProfileInfo = styled.div`
  flex: 1 1 auto;
  padding-left: 8px;
  position: relative;
  min-width: 0;
`;

export const SidebarProfileName = styled.div`
  display: block;
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.2;
  color: #fff;
  padding-right: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    display: inline;
  }
`;

export const SidebarProfilePicture = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: #e63946;
  color: #fff;
  font-weight: 700;
  font-size: 11px;
`;

export const SidebarProfileLogoutButton = styled.div`
  display: block;
  position: absolute;
  top: 50%;
  transform: translateY(-15px);
  right: 0;
  width: 24px;
  height: 30px;
  background-image: url('${IconExit}');
  background-repeat: no-repeat;
  background-size: 14px;
  background-position: center;
  cursor: pointer;
  opacity: 0.5;
  transition-property: opacity;
  transition-duration: 0.2s;
  &:hover {
    opacity: 1;
  }
`;

export const SidebarProfilePosition = styled.div`
  display: block;
  margin-top: 3px;
  font-style: normal;
  font-weight: 400;
  font-size: 9px;
  line-height: 1;
  color: #888;
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const SidebarArrow = styled.img`
  transform: rotate(90deg);
  transition: transform 0.2s;
  margin-left: auto;
  opacity: 0.5;
  width: 8px;
  flex-shrink: 0;
  &.isOpen {
    transform: rotate(180deg);
  }
`;
